// extracted by mini-css-extract-plugin
export var createdDate = "_mo-1";
export var divider = "_mo-2";
export var headerDivider = "_mo-3";
export var messagesCard = "_mo-0";
export var messagesContainer = "_mo-7";
export var messagesContainerWrapper = "_mo-4";
export var pointerCapturingButtonBoxes = "_mo-a";
export var showLeftPanelButton = "_mo-9";
export var showMoreButton = "_mo-c";
export var showMoreButtonContainer = "_mo-b";
export var summaryTitle = "_mo-6";
export var systemMessageCardWrapper = "_mo-d";
export var topButtons = "_mo-8";
export var withPadding = "_mo-5";